interface MenuButtonProps {
  label: string;
  size?: 'text-xs' | 'text-sm' | 'text-base' | 'text-lg' | 'text-xl';
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const SubmitButton = ({ label, onClick, disabled }: MenuButtonProps) => {
  return (
    <button
      disabled={disabled || false}
      onClick={onClick}
      style={{
        width: '100%',
        height: '48px',
        color: '#FFFFFF',
        textAlign: 'left',
        margin: '32px auto'
      }}
      className="bg-primary flex relative rounded disabled:opacity-75"
    >
      <div className="text-base m-auto font-bold" style={{ whiteSpace: 'pre-wrap' }}>
        {label}
      </div>
    </button>
  );
};
